// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNav-SidePanel-module--cls1--34IFY","cls2":"SideNav-SidePanel-module--cls2--1PH6H SideNav-SidePanel-module--cls1--34IFY d-flex flex-column"};